import { defaultLocale, localeUrlSlug, resolveLocale, type Locale } from "@/lib/i18n/config";

/** Prefix a path with the locale's URL segment (default locale = no prefix). */
export function localizePath(path: string, locale: Locale = defaultLocale): string {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const slug = localeUrlSlug(locale);
  if (!slug) return cleanPath;
  return cleanPath === "/" ? `/${slug}` : `/${slug}${cleanPath}`;
}

/** Strip a locale prefix from a pathname, returning the resolved locale and the remaining path. */
export function extractLocaleFromPath(pathname: string): { locale: Locale; path: string } {
  const segments = pathname.split("/").filter(Boolean);
  const matched = segments[0] ? resolveLocale(segments[0]) : null;
  if (matched && matched !== defaultLocale) {
    segments.shift();
    return { locale: matched, path: `/${segments.join("/")}` };
  }
  return { locale: defaultLocale, path: pathname };
}
